import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import SVG from 'react-inlinesvg';
import OpenGraphTitle from '../components/OpenGraphTitle';
import OpenGraphDescription from '../components/OpenGraphDescription';
import Head from '../components/head';
import { FranchiseeProvider } from '../context/Franchisee';
import { Document, Page, pdfjs } from 'react-pdf';
import Layout from '../components/Layout';
import Section from '../components/Section';

const iconSparkles = '/images/sparkles-two.svg';
const iconNeighborhood = '/images/icon-neighborhood.svg';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

interface WelcomePacketProps {
}

const WelcomePacket: React.FC<WelcomePacketProps> = ({}: WelcomePacketProps) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const handleNextPage = () => {
    if (pageNumber !== numPages) {
      setPageNumber(pageNumber + 1);
    } else {
      return;
    }
  }

  const handlePrevPage = () => {
    if (pageNumber != 1) {
      setPageNumber(pageNumber - 1);
    } else {
      return;
    }
  }

  return (
      <FranchiseeProvider>
        <Layout alternateFooter>
          <Head
            slug='welcome-packet'
            title='Welcome Packet | Two Maids '
            description='Two Maids  Welcome Packet'
            />
          <OpenGraphTitle title='Welcome Packet | Two Maids ' />
          <OpenGraphDescription>
            Two Maids  Welcome Packet
          </OpenGraphDescription>
          <Section>
            <div className='welcome-packet-button-container'>
              <button className='welcome-packet-button page-link' onClick={() => handlePrevPage()}>Prev</button>
              <p style={{textAlign: 'right'}}>
                Page {pageNumber} of {numPages}
              </p>
              <button className='welcome-packet-button page-link' onClick={() => handleNextPage()}>Next</button>
            </div>
            <Document file='https://res.cloudinary.com/twomaidsengi/image/upload/v1674508330/hubsite-reskin/Two_Maids_Welcome_Packet_email.pdf' onLoadSuccess={onDocumentLoadSuccess}>
                <Page renderAnnotationLayer={false} renderTextLayer={false} className="welcome-packet-content" pageNumber={pageNumber}/>
            </Document>
          </Section>
        </Layout>
      </FranchiseeProvider>
  );
};

export default WelcomePacket;
